module.exports = __webpack_public_path__ + "static/media/iphone_11_pro_silver.c2d89b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_11_pro_silver.png
// module id = 2119
// module chunks = 0